import initialState from './_initialReducerState';
import type {
  ModuleEntitlementsState,
  ModuleEntitlementSnapshot,
} from '@/uptk/core/entitlements/module_entitlement_storage';
import {
  MODULE_ENTITLEMENTS_ERROR,
  MODULE_ENTITLEMENTS_LOADED,
  MODULE_ENTITLEMENTS_LOADING,
  MODULE_ENTITLEMENTS_RESET,
  type ModuleEntitlementsAction,
} from '@/redux/actions/module_entitlements_actions';

const defaultState: ModuleEntitlementsState = {
  status: 'idle',
  tenantId: null,
  updatedAt: null,
  entitlements: {},
  error: null,
};

const resolveInitialState = () => {
  const seeded = (initialState as { moduleEntitlements?: ModuleEntitlementsState }).moduleEntitlements;
  return seeded ?? defaultState;
};

const applySnapshot = (
  state: ModuleEntitlementsState,
  snapshot: ModuleEntitlementSnapshot
): ModuleEntitlementsState => ({
  ...state,
  status: 'loaded',
  tenantId: snapshot.tenantId,
  updatedAt: snapshot.updatedAt,
  entitlements: snapshot.entitlements,
  error: null,
});

export default function moduleEntitlementsReducer(
  state: ModuleEntitlementsState = resolveInitialState(),
  action: ModuleEntitlementsAction
): ModuleEntitlementsState {
  switch (action.type) {
    case MODULE_ENTITLEMENTS_LOADING:
      return {
        ...state,
        status: 'loading',
        error: null,
      };
    case MODULE_ENTITLEMENTS_LOADED:
      return applySnapshot(state, action.payload);
    case MODULE_ENTITLEMENTS_ERROR:
      return {
        ...state,
        status: 'error',
        error: action.error,
      };
    case MODULE_ENTITLEMENTS_RESET:
      return resolveInitialState();
    default:
      return state;
  }
}
